"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageType = void 0;
var DamageType;
(function (DamageType) {
    DamageType[DamageType["None"] = 0] = "None";
    DamageType[DamageType["All"] = 10] = "All";
    DamageType[DamageType["Chaos"] = 11] = "Chaos";
    DamageType[DamageType["Death"] = 12] = "Death";
    DamageType[DamageType["Fire"] = 13] = "Fire";
    DamageType[DamageType["Frost"] = 14] = "Frost";
    DamageType[DamageType["Holy"] = 15] = "Holy";
    DamageType[DamageType["Nature"] = 16] = "Nature";
    DamageType[DamageType["Physical"] = 17] = "Physical";
    DamageType[DamageType["Sonic"] = 18] = "Sonic";
})(DamageType = exports.DamageType || (exports.DamageType = {}));
